import React from "react";
import "./Loader.css";

export default function Loader({ label = "Loading…" }) {
  return (
    <div className="loader-wrap">
      <div className="loader-spinner" />
      <span className="loader-label">{label}</span>
    </div>
  );
}